<template>
  <div class="recommend">
    <div class="content">
      <div class="merchantRe">{{ $t('homePage.exhibition.title') }}</div>
      <!-----展商推荐列表------->
      <div class="box">
        <div class="item" v-for="(item, index) in merchantsExhibits" :key="index" @click="goDetail(item.id)">
          <div class="left"><img :src="item.leftImgUrl" alt="" /></div>
          <div class="right">
            <div class="top">
              <p class="title">{{ item.title }}</p>
              <p class="txt">
                <span>{{ $t('common.boothNum1') }}</span
                >{{ addcomma(item.txt) }}
              </p>
            </div>
            <div class="bottom">
              <div>
                <a href="#" @click.prevent="goDetail(item.id)">{{ $t('common.more') }}</a>
              </div>
              <div class="rightIcon">
                <span class="consult" @click.stop="consult(item)"
                  ><img src=".././../static/consultingBlack.png" alt="" />
                  <div class="hoversty1">{{ $t('common.consult') }}</div></span
                >
                <span class="bottomImg" @click.stop="collection(item, 1)">
                  <img v-if="item.collectStatus" alt="" src="../../static/collent_yello.png" />
                  <!--显示金色-->
                  <img v-else alt="" src="../../static/collen1t.png" /><!--显示无色-->
                  <div class="hoversty">{{ item.collectStatus ? $t('common.clearCollect') : $t('common.collect') }}</div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--查看更多-->
      <router-link to="exhibition"
        ><div class="lookMore">{{ $t('common.viewMore') }}</div></router-link
      >
    </div>
  </div>
</template>
<script>
import { getrecommendedExhibitor, addCollect } from '../../../api/homePage';
import { forMat } from '../../../utils/common';
import * as tools from '../../../utils/roulink';

export default {
  props: ['lang'],
  data() {
    return {
      //商家推荐
      merchantsExhibits: [],
      lang: 'zh'
    };
  },
  methods: {
    consult(item) {
      tools.login(1, item.id);
    },
    async getrecommendedExhibitor() {
      try {
        let { data } = await getrecommendedExhibitor();
        data.data.list.forEach((item, i) => {
          if(item.comCover.indexOf("http")  == -1){
            item.comCover= forMat() +  item.comCover;
          }
          console.log('item',item);
          this.merchantsExhibits.push({
            id: item.id,
            leftImgUrl: item.comCover,
            title: this.lang == 'zh' ? item.companyNameC : item.companyNameE ,
            collectStatus: item.collectStatus,
            // txt:item.hzBoothList[0].boothNum
          });
          item.hzBoothList.length > 0
            ? (this.merchantsExhibits[i].txt = item.hzBoothList.map((item) => {
                return item.boothNum;
              }))
            : (this.merchantsExhibits[i].txt = this.$t('homePage.exhibition.no'));
        });
      } catch (e) {
        console.log(e);
      }
    },

    addcomma(arr) {
      return arr.join('、');
    },

    //使用父组件收藏方法
    collection(item, type) {
      this.$parent.collection(item, type);
    },

    //
    //跳转
    goDetail(id) {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id,
        },
      });
    },
  },
  created() {
    this.getrecommendedExhibitor();
  },
};
</script>
<style lang="scss" scoped>
.recommend {
  background-image: url('../../static/IMG_recom.png');
  padding-bottom: 70px;
  .content {
    width: 1270px;
    margin: 0 auto;
    padding-top: 81px;
    height: fit-content;
    .merchantRe {
      width: 100%;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .box {
      width: 100%;

      margin-top: 54px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item:hover {
        box-shadow: 2px 2px 10px #9fa3a5;
      }
      .item {
        width: 620px;
        height: 170px;
        border: 1px solid #e0e0e0;
        margin-bottom: 28px;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        background-color: white;

        .left {
          width: 294px;
          height: 170px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #e0e0e0;
          padding: 23px 40px;
          box-sizing: border-box;
          img {
            max-width: 254px;
            max-height: 170px;
          }
        }
        .right {
          flex: 1;
          height: 170px;

          .top {
            width: 100%;
            height: 114px;
            padding-top: 30px;
            box-sizing: border-box;
            padding-left: 30px;
            box-sizing: border-box;
            .title {
              font-size: 19px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              width: 100%;
              max-width: 293px;
              text-overflow: -o-ellipsis-lastline;
              // overflow: hidden;
              text-overflow: ellipsis;
              // white-space: nowrap;
            }
            .txt {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 800;
              margin-top: 5px;
              /*   color: gold; */
              color: #333333;
              width: 100%;
              max-width: 293px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              span {
                font-weight: 400;
                color: #333333;
              }
            }
          }
          .bottom {
            width: 100%;
            height: 56px;
            border-top: 1px solid #e0e0e0;
            padding-left: 30px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            a {
              display: block;
              height: 56px;
              line-height: 56px;
              text-decoration: none;
              font-size: 17px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            .rightIcon {
              height: 56px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-right: 20px;
              box-sizing: border-box;
              position: relative;
              span {
                width: 30px;
                height: 29px;
                background: #ffffff;
                margin-left: 25px;
                img {
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                }
              }
              .hoversty1 {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                top: 6px;
                left: 55px;
                line-height: 40px;
                cursor: pointer;
              }
              .hoversty {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                top: 6px;
                left: 115px;
                line-height: 40px;
                cursor: pointer;
              }
              .bottomImg:hover .hoversty {
                display: block;
              }
              .consult:hover .hoversty1 {
                display: block;
              }
            }
          }
        }

        &:hover {
          color: #006fb8 !important;
          .top {
            .txt {
              color: #006fb8 !important;
              span {
                color: #006fb8 !important;
              }
            }
          }
          .bottom {
            a {
              color: #006fb8 !important;
            }
          }
        }
      }
    }
    a {
      text-decoration: none;
      .lookMore {
        width: 247px;
        height: 44px;
        border: 1px solid #333333;
        border-radius: 4px;
        margin: 0 auto;
        text-align: center;
        line-height: 44px;
        margin-top: 12px;
        color: #333333;
        font-size: 16px;
      }
    }
  }
}
</style>
